import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {SickLeaveRequest} from '../services/sick-leave.service';
import {dateRangeValidator, endDateAfterStartValidator} from './validators';

// Gemeinsame Form-Definition für "Krankmeldung erstellen" (volle Seite und Mitarbeiter-Modal):
// beide bauen exakt dieselben Felder/Validatoren auf, vorher unabhängig voneinander dupliziert.
// Ein evtl. zusätzliches Feld (z.B. employeeId auf der vollen Seite) fügt der Aufrufer selbst per
// form.addControl() hinzu - buildSickLeaveRequest() liest ohnehin nur die hier definierten Felder.
export function buildSickLeaveForm(fb: FormBuilder): FormGroup {
    return fb.group({
        startDate: [getCurrentDate(), Validators.required], // Set current date as default
        endDate: ['', Validators.required], // Backend (NewEau) verlangt end_work_incapacity_au zwingend
        isFollowUp: [false],
        mitAttest: [false],
    }, {validators: dateRangeValidator});
}

export function getCurrentDate(): string {
    const today = new Date();
    return today.toISOString().split('T')[0];
}

// setValidators() ersetzt alle bisherigen Validatoren auf diesem Control - das Validators.required
// aus der FormBuilder-Definition muss daher hier erneut mit aufgeführt werden, sonst ginge es
// verloren.
export function attachEndDateValidator(form: FormGroup): void {
    form.get('endDate')?.setValidators([
        Validators.required,
        endDateAfterStartValidator(form)
    ]);

    form.get('startDate')?.valueChanges.subscribe(() => {
        form.get('endDate')?.updateValueAndValidity();
    });
}

export function buildSickLeaveRequest(form: FormGroup, employeeNumber: number): SickLeaveRequest {
    const formValue = form.value;
    return {
        employeeNumber,
        start_work_incapacity: formValue.startDate,
        end_work_incapacity_au: formValue.endDate,
        follow_up_certification: formValue.isFollowUp,
        mit_attest: formValue.mitAttest,
    };
}
